import VueRouter from "vue-router";

import { usersRoutes } from "./users";
import { authRoutes } from "./auth";
import { rolesRoutes } from "./roles";
import { suppliersRoutes } from "./suppliers";
import { companiesRoutes } from "./companies";
import { customersRoutes } from "./customers";
import { countriesRoutes } from "./countries";
import { ordersRoutes } from "./orders";
import { itemsRoutes } from "./items";
import { itemCategoriesRoutes } from "./itemCategories";
import { rulesRoutes } from "./rules";
import { framesRoutes } from "./frames";
import { wallConnectionsRoutes } from "./wallConnections";
import { labelTypesRoutes } from "./labelTypes";
import { numberRangesRoutes } from "./numberRanges";
import { typeCategoriesRoutes } from "./typeCategories";
import { udTablesRoutes } from "./udTables";
import { doorTypesRoutes } from "./doorTypes";
import { ruleGroupsRoutes } from "./ruleGroups";
import { edgeSpacersRoutes } from "./edgeSpacers";
import { documentsRoutes } from "./documents";
import { dashboardRoutes } from "./dashboard";
import { labelordersRoutes } from "./labelorders";
import { labelEntriesRoutes } from "./labelEntries";
import { orderPositionsRoutes } from "./orderPositions";
import { statisticsRoutes } from "./statistics";

import Index from "./shared/components/template/dashboard/Index";
import PageIndex from "./shared/components/template/pages/Index";

import { AppPageNotFound, AppUnauthorized } from "./shared/components";
import Vue from "vue";

Vue.use(VueRouter);

const appRoutes = [
  {
    path: "/",
    component: Index,
    children: [
      ...usersRoutes,
      ...dashboardRoutes,
      ...statisticsRoutes,
      ...rolesRoutes,
      ...suppliersRoutes,
      ...companiesRoutes,
      ...customersRoutes,
      ...countriesRoutes,
      ...ordersRoutes,
      ...itemsRoutes,
      ...itemCategoriesRoutes,
      ...rulesRoutes,
      ...framesRoutes,
      ...wallConnectionsRoutes,
      ...labelTypesRoutes,
      ...numberRangesRoutes,
      ...typeCategoriesRoutes,
      ...udTablesRoutes,
      ...doorTypesRoutes,
      ...ruleGroupsRoutes,
      ...documentsRoutes,
      ...edgeSpacersRoutes,
      ...labelordersRoutes,
      ...labelEntriesRoutes,
      ...orderPositionsRoutes
    ]
  },
  {
    path: "/",
    component: PageIndex,
    children: [...authRoutes]
  },
  {
    path: "/403",
    name: "unauthorized",
    component: AppUnauthorized
  },
  {
    path: "*",
    name: "page-not-found",
    component: AppPageNotFound
  }
];

const routes = [...appRoutes];

export default new VueRouter({
  mode: "history",
  routes
});
